import React, { useState } from 'react';
import Header from './Header';
import Footer from './Footer';

const Layout = (props) => {
  const user = localStorage.getItem('name');
  const role = localStorage.getItem('role');
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div>
      <Header
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
        Heading="SuperAdmin"
        Btn="42"
        P1="Dashboard"
        R1="/Home"
        i1="bi bi-grid"
        Ac1={props.ac1}
        P2="Manage Clients"
        R2="/ViewClient"
        i2="bi bi-person-fill-gear"
        Ac2={props.ac2}
        P3="Manage Admins"
        R3="/ViewAdmins"
        i3="bi bi-person-fill-add"
        Ac3={props.ac3}
        P4="Profile"
        R4="/Account"
        i4="bi bi-person-circle"
        Ac4={props.ac4}
        op="Profile"
        opr="/Account"
        opi="bi bi-person-circle"
        op1="History"
        opr1="/SuparAdminHistory"
        opi1="bi bi-clock-history"
        user={user}
        role={role}
        h1="/Home"
      />
      <main className={` main ${sidebarOpen ? 'open' : 'close'}`}>
        <div className="main-herder">{props.children}</div>
        <Footer />
      </main>
    </div>
  );
};

export default Layout;
